import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgbDropdownButtonItem, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';
import { ContextMenuComponent, PanelComponent, PanelHeaderComponent, TitleComponent } from '@rocksoft/cdk';
import { Group } from '@rocksoft/security-sdk';
import { MemberListUserItemsContainerComponent } from '../../users/list-user-items/member-list-user-items.container';
import { MemberListGroupItemsContainerComponent } from '../list-group-items/member-list-group-items.container';

@Component({
  selector: 'era-security-member-list-ui',
  templateUrl: './member-list.component.html',
  styleUrls: ['./member-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    PanelComponent,
    PanelHeaderComponent,
    TitleComponent,
    ContextMenuComponent,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    RouterLink,
    MemberListGroupItemsContainerComponent,
    MemberListUserItemsContainerComponent,
  ],
})
export class MemberListComponent {
  public readonly group = input<Group>();
  public readonly editEnabled = input<boolean>();

  public readonly toggleEditEvent = output();
  public readonly addUserEvent = output();
  public readonly addGroupEvent = output();

  toggleEdit() {
    this.toggleEditEvent.emit();
  }

  addUser() {
    this.addUserEvent.emit();
  }

  addGroup() {
    this.addGroupEvent.emit();
  }
}
